import { render, staticRenderFns } from "./fees-costs-loader.vue?vue&type=template&id=0dde1b29"
import script from "./fees-costs-loader.vue?vue&type=script&lang=js"
export * from "./fees-costs-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports